// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CitationResponse
 */
export interface CitationResponse {
    /**
     * 
     * @type {string}
     * @memberof CitationResponse
     */
    passageId: string;
    /**
     * 
     * @type {string}
     * @memberof CitationResponse
     */
    documentName: string;
    /**
     * 
     * @type {number}
     * @memberof CitationResponse
     */
    relevanceScore: number;
    /**
     * 
     * @type {string}
     * @memberof CitationResponse
     */
    citationText: string;
    /**
     * 
     * @type {number}
     * @memberof CitationResponse
     */
    documentNumber: number;
    /**
     * 
     * @type {string}
     * @memberof CitationResponse
     */
    docUrl: string;
    /**
     * 
     * @type {CitationResponseSourceTypeEnum}
     * @memberof CitationResponse
     */
    sourceType: CitationResponseSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CitationResponse
     */
    passageText: string;
    /**
     * 
     * @type {string}
     * @memberof CitationResponse
     */
    scrapingSource: string;
    /**
     * 
     * @type {string}
     * @memberof CitationResponse
     */
    modifiedAt: string;
}


/**
 * @export
 */
export const CitationResponseSourceTypeEnum = {
    Sharepoint: 'sharepoint',
    Tqm: 'tqm',
    Webscraping: 'webscraping'
} as const;
export type CitationResponseSourceTypeEnum = typeof CitationResponseSourceTypeEnum[keyof typeof CitationResponseSourceTypeEnum];


/**
 * Check if a given object implements the CitationResponse interface.
 */
export function instanceOfCitationResponse(value: object): value is CitationResponse {
    if (!('passageId' in value) || value['passageId'] === undefined) return false;
    if (!('documentName' in value) || value['documentName'] === undefined) return false;
    if (!('relevanceScore' in value) || value['relevanceScore'] === undefined) return false;
    if (!('citationText' in value) || value['citationText'] === undefined) return false;
    if (!('documentNumber' in value) || value['documentNumber'] === undefined) return false;
    if (!('docUrl' in value) || value['docUrl'] === undefined) return false;
    if (!('sourceType' in value) || value['sourceType'] === undefined) return false;
    if (!('passageText' in value) || value['passageText'] === undefined) return false;
    if (!('scrapingSource' in value) || value['scrapingSource'] === undefined) return false;
    if (!('modifiedAt' in value) || value['modifiedAt'] === undefined) return false;
    return true;
}

export function CitationResponseFromJSON(json: any): CitationResponse {
    return CitationResponseFromJSONTyped(json, false);
}

export function CitationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CitationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'passageId': json['passage_id'],
        'documentName': json['document_name'],
        'relevanceScore': json['relevance_score'],
        'citationText': json['citation_text'],
        'documentNumber': json['document_number'],
        'docUrl': json['doc_url'],
        'sourceType': json['source_type'],
        'passageText': json['passage_text'],
        'scrapingSource': json['scraping_source'],
        'modifiedAt': json['modified_at'],
    };
}

export function CitationResponseToJSON(json: any): CitationResponse {
    return CitationResponseToJSONTyped(json, false);
}

export function CitationResponseToJSONTyped(value?: CitationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'passage_id': value['passageId'],
        'document_name': value['documentName'],
        'relevance_score': value['relevanceScore'],
        'citation_text': value['citationText'],
        'document_number': value['documentNumber'],
        'doc_url': value['docUrl'],
        'source_type': value['sourceType'],
        'passage_text': value['passageText'],
        'scraping_source': value['scrapingSource'],
        'modified_at': value['modifiedAt'],
    };
}

